import React from "react";
import { CloseIcon } from "@icarius-icons";
import {
    Typography,
    DialogContent,
    DialogActions,
    DialogTitle,
    Dialog,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import DialogTransition from "@icarius-common/dialogTransition";
import { getLocalizedString } from "@icarius-localization/strings";

const ConfirmationDialog = (props) => {

    const {
        open,
        handleConfirm,
        handleClose,
    } = props;

    return (
        <Dialog
            TransitionComponent={DialogTransition}
            open={open}
            scroll={"paper"}
            maxWidth={"md"}>
            <DialogTitle>
                {getLocalizedString("atention")}
                <DialogTitleDivider />
            </DialogTitle>
            <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
            <DialogContent style={{ paddingTop: 0 }}>
                <Typography className="whiteText" variant="h6" gutterBottom>
                    {getLocalizedString("unsavedChangesConfirmation")}
                </Typography>
            </DialogContent>
            <DialogActions>
                <ButtonDialogAction onClick={handleClose} text={getLocalizedString("stay")} />
                <ButtonDialogAction onClick={handleConfirm} isAccept text={getLocalizedString("exitAction")} />
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmationDialog;
